import { render, staticRenderFns } from "./vipGiftPack.vue?vue&type=template&id=5ac217a8&scoped=true"
import script from "./vipGiftPack.vue?vue&type=script&lang=js"
export * from "./vipGiftPack.vue?vue&type=script&lang=js"
import style0 from "./vipGiftPack.vue?vue&type=style&index=0&id=5ac217a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac217a8",
  null
  
)

export default component.exports